import { useNavigate } from "react-router-dom";
import { verifyRecieverRejected } from "../../apiEndpoints";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import usePostData from "../../../../CustomHooks/useAxios/usePostData";

export const VerifyExpense = ({ setVerifyDialog, verifyDetails }) => {
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();
  const navigate = useNavigate();
  const { expenseId, receiver } = verifyDetails;

  const verifyExpense = () => {
    console.log(verifyRecieverRejected(expenseId), "vrekl;f")
    executePost(() => { }, verifyRecieverRejected(expenseId));
  };

  const closeDialog = () => setVerifyDialog(false);

  return (
    <Modal
      onClose={loading || successResponse ? undefined : closeDialog}
      modalWidth="w-11/12 max-sm:w-[95%] max-md:p-4 py-7 px-6 max-w-sm"
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5"> Expense verified successfully.</p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate(0)}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("")}
              />
            )}
            <p className="text-md mb-2 text-center">Do you want to verify this expense?</p>
            <p className="text-gray-500 text-sm italic text-center">
              The expense was rejected by{" "}
              <span className="font-semibold ">{receiver}</span>
            </p>
            <div className="flex gap-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-2 mb-4">
              <span className="text-amber-500 text-sm leading-5">ⓘ</span>
              <p className="text-amber-800 text-xs leading-5">
                Verifying this expense will remove this expense from the rejected list.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-2">
              <GrayButton
                onClick={closeDialog}
                btnText="Cancel"
                disabled={loading}
              />
              <button
                onClick={verifyExpense}
                className="bg-emerald-100 hover:bg-emerald-50 text-emerald-600 transition-all px-3 py-1 rounded-md"
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify"}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
};
